import {Linking} from 'react-native';
import {goCS, goTo} from '@/utils';
import {apiSendPhoneCode, defaultPhoneCode, packageId} from '@/config';

export function toAgentApply() {
  goTo('AgentRules');
}

export const goAgentService = () => {
  const linkMap: Record<number, string> = {
    3: 'https://nimble.li/v9a88qqd',
  };
  const whatsAppLink = linkMap[packageId];
  if (whatsAppLink) {
    Linking.openURL(whatsAppLink);
  } else {
    goCS();
  }
};

export function goWhatsAppChat(userPhone?: string, message?: string) {
  if (!userPhone) {
    return;
  }
  Linking.openURL(
    `https://wa.me/${(apiSendPhoneCode ? '' : defaultPhoneCode) + userPhone}${
      message ? `?text=${encodeURIComponent(message)}` : ''
    }`,
  );
}
